import type { TemplateId } from "@/components/landing/StoreCustomizer/types";
import { TEMPLATE_VISUALS } from "@/components/landing/StoreCustomizer/config";

interface ThemePickerProps {
	label: string;
	templates: Record<TemplateId, string>;
	templateId: TemplateId;
	accent: string;
	onChange: (id: TemplateId) => void;
}

function ThemePicker(prop: ThemePickerProps) {
	const { label, templates, templateId, accent, onChange } = prop;
	return (
		<div>
			<p className="mb-2.5 text-xs font-semibold text-muted-foreground">{label}</p>
			<div role="radiogroup" aria-label={label} className="flex gap-2">
				{(Object.keys(templates) as TemplateId[]).map((id) => {
					const isActive = id === templateId;
					const v = TEMPLATE_VISUALS[id];
					return (
						<button
							key={id}
							type="button"
							role="radio"
							aria-checked={isActive}
							onClick={() => onChange(id)}
							className="flex flex-1 flex-col items-center gap-1.5 border px-1.5 py-2 text-[11px] font-medium transition-colors"
							style={{
								borderRadius: 10,
								borderColor: isActive ? accent : "var(--border)",
								background: isActive
									? "color-mix(in srgb, var(--brand-2) 8%, transparent)"
									: "var(--surface)",
								color: isActive ? "var(--text)" : "var(--text-muted)",
							}}
						>
							<span
								className="h-3.5 w-full"
								style={{
									borderRadius: v.buttonRadius > 100 ? 999 : v.panelRadius * 0.35,
									background: isActive ? accent : "var(--surface-2)",
								}}
								aria-hidden
							/>
							{templates[id]}
						</button>
					);
				})}
			</div>
		</div>
	);
}

export default ThemePicker;
